import { render, staticRenderFns } from "./ModalMedicine.vue?vue&type=template&id=0d8c25e0"
import script from "./ModalMedicine.vue?vue&type=script&lang=js"
export * from "./ModalMedicine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports